<script setup>
import { computed } from 'vue'
import { CREST_SHAPES, crestStyle } from '@/lib/crests'

/**
 * The crest a player wears next to their name: the badge chosen on the settings page, drawn with the
 * colours of that player's livery (see the server's PlayerFlairLib, which sends it already resolved).
 *
 * It is exactly as tall as the text it stands in front of, so a table row keeps the height it had
 * before the badge existed. A shape or a colour the client does not know draws nothing: half a crest
 * is worse than no crest.
 */
const props = defineProps({
  /** { shape, colors } as the API sends it; null for a player who wears none. */
  crest: { type: Object, default: null },
})

const css = computed(() => {
  const shape = props.crest?.shape

  return CREST_SHAPES[shape] ? crestStyle(shape, props.crest.colors ?? []) : null
})
</script>

<template>
  <span v-if="css" class="player-crest" :style="css" aria-hidden="true"></span>
</template>

<style scoped>
.player-crest {
  display: inline-block;
  width: 1.1em;
  height: 1.1em;
  margin-right: 0.25em;
  border-radius: 0.18em;
  vertical-align: -0.15em;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.15);
}
</style>
